import React from "react";
import { Modal, Spin, Table, Space } from "antd";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { getUserList } from "redux/selectors";
import dayjs from "dayjs";

const ModalWrap = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
  }
`;

const AssetHistoryModal = ({ open, onClose, historyData = [], loading }) => {
  const userList = useSelector(getUserList);
  const columns = [
    {
      title: "Between",
      dataIndex: "assigned_on",
      render: (_, record) => {
        return (
          <Space>
            {dayjs(record?.assigned_on).format("DD MMM YYYY")}
            {record?.revoked_on &&
              `- ${dayjs(record?.revoked_on).format("DD MMM YYYY")}`}
          </Space>
        );
      },
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: (userid) => {
        return userList?.find((u) => u?.userid === userid)?.fullname || "-";
      },
    },
    {
      title: "Assigned By",
      dataIndex: "assigned_by",
      render: (userid) => {
        return userList?.find((u) => u?.userid === userid)?.fullname || "-";
      },
    },
    {
      title: "Revoked By",
      dataIndex: "revoked_by",
      render: (userid) => {
        return userList?.find((u) => u?.userid === userid)?.fullname || "-";
      },
    },
  ];

  return (
    <ModalWrap
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      width={1000}
      title="Asset History"
    >
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={historyData}
          pagination={false}
          rowKey="id"
        />
      </Spin>
    </ModalWrap>
  );
};

export default AssetHistoryModal;
